import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useMergerModel } from "./summaryModel";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
    } = useMergerModel();


    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "客户名称",
            fieldName: "customerName",
            size: "small",
            disabled: false
        },
    ]

    return (
        <YhPageHeader
            title="客户合并"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}